import { axiosObj } from './api.service'

export const postInquiryService = async (payload: any): Promise<any> => {
  try {
    const { data }: { data: any } = await axiosObj({
      jwtToken: payload.jwtToken,
    }).post(`inquiries/${payload.patientId}`, { question: payload.question })
    return data
  } catch (e) {
    throw e
  }
}

export const putInquiryService = async (payload: any): Promise<any> => {
  try {
    const { data }: { data: any } = await axiosObj({
      jwtToken: payload.jwtToken,
    }).put(
      `inquiries/details/${payload.inquiryId}`,
      payload.inquiry.answers
        ? {
            inquiryId: payload.inquiry.inquiryId,
            inquiryNumber: payload.inquiry.inquiryNumber,
            userId: payload.inquiry.userId,
            username: payload.inquiry.username,
            question: payload.inquiry.question,
            isNew: payload.inquiry.isNew,
            createdAt: payload.inquiry.createdAt,
            updatedAt: payload.inquiry.updatedAt,
            isClosed: payload.inquiry.isClosed,
            answers: [
              ...payload.inquiry.answers,
              {
                userId: payload.userId,
                username: payload.username,
                answer: payload.answer,
                createdAt: payload.createdAt,
                role: payload.role,
              },
            ],
          }
        : {
            inquiryId: payload.inquiry.inquiryId,
            inquiryNumber: payload.inquiry.inquiryNumber,
            userId: payload.inquiry.userId,
            username: payload.inquiry.username,
            question: payload.inquiry.question,
            isNew: payload.inquiry.isNew,
            createdAt: payload.inquiry.createdAt,
            updatedAt: payload.inquiry.updatedAt,
            isClosed: payload.inquiry.isClosed,
            answers: [
              {
                userId: payload.userId,
                username: payload.username,
                answer: payload.answer,
                createdAt: payload.createdAt,
                role: payload.role,
              },
            ],
          }
    )
    return data
  } catch (e) {
    throw e
  }
}



// WEBPACK FOOTER //
// ./src/services/inquiry.service.tsx